import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class NavigationComponentService {
  openSideMenu$ = new Subject();
  closeNavigation$ = new Subject();
}
